import { render, staticRenderFns } from "./QATestRequest.vue?vue&type=template&id=597f72d9&scoped=true&"
import script from "./QATestRequest.vue?vue&type=script&lang=js&"
export * from "./QATestRequest.vue?vue&type=script&lang=js&"
import style0 from "./QATestRequest.vue?vue&type=style&index=0&id=597f72d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597f72d9",
  null
  
)

export default component.exports